import { Outlet } from "react-router-dom";
import ElevatedPaper from "../../../../components/ElevatedPaper";
import PageLayout from "../../../../components/PageLayout";

const CollaborationLayout = () => {
  return (
    <ElevatedPaper>
      <PageLayout>
        <Outlet />
      </PageLayout>
    </ElevatedPaper>
  );
};

export default CollaborationLayout;
